export default {
      id: "ic-statistics-off-usage",
      viewBox: "0 0 32 32",
      url: "/" + "images/icons.3.109.2.svg#ic-statistics-off-usage",
      toString: function () {
        return this.url;
      }
    }